// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"90110d7b","217":"7974f96a","240":"b4a174a3","371":"b105fc5c","550":"ecd76e4e","615":"b845e953","722":"1e98c56d","855":"bb093e83","918":"6fbdde7c"}[chunkId] + ".chunk.css";
};